import { render, staticRenderFns } from "./ProjectEventName.vue?vue&type=template&id=efc3b9c2&scoped=true&"
import script from "./ProjectEventName.vue?vue&type=script&lang=js&"
export * from "./ProjectEventName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc3b9c2",
  null
  
)

export default component.exports